export default __webpack_public_path__ + "static/media/close.deaf104d.svg";